import type { FC } from "react";

import { Image } from "@/ui/components/primitives/Image";
import type { TCalloutAssetProps } from "./Callout.config";
import { isCalloutAssetImage } from "./Callout.guards";
import { CalloutAssetWrapper } from "./CalloutAssetWrapper";

export const CalloutAsset: FC<TCalloutAssetProps> = ({ asset }) => (
  <CalloutAssetWrapper asset={asset}>
    { asset && isCalloutAssetImage(asset) ? <Image {...asset} /> : null }
  </CalloutAssetWrapper>
);
